import "../../../../styles/historyDocumentsComponent.scss";

import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import SearchBar from "../order/SearchBar.jsx";
import TobaccoDisplayCard from "../product/TobaccoDisplayCard";
import TobaccoReturnCart from "./TobaccoReturnCart";
import {scssVariables} from "../../../common/util/config.jsx";

export default class HistoryTobakComponent extends React.PureComponent {
    constructor(props) {
        super(props);

        this.filterSettings = {
            ReturnTobacco: true,
            OnlyCampaigns: false,
            OnlyNews: false,
            OnlyLastSold: false,
        };

        this.onEditFilter = this.onEditFilter.bind(this);
        this.loadMoreSearchResaults = this.loadMoreSearchResaults.bind(this);
        this.calculateCartHeight = this.calculateCartHeight.bind(this);
        this.calculateProductDisplayHeight = this.calculateProductDisplayHeight.bind(this);
        this.calculateProductDisplayWidth = this.calculateProductDisplayWidth.bind(this);
    }
    UNSAFE_componentWillMount() {
        const {
            clearQuery,
            getTobaccoSuppliers,
            prepareQueryOptions,
            getBoughtProducts,
            getNewProducts,
            productQuery,
            getSavedTobaccoReturn,
        } = this.props;
        clearQuery();
        getTobaccoSuppliers();
        prepareQueryOptions(true);
        getBoughtProducts();
        getNewProducts();
        getSavedTobaccoReturn();
        //
        this.onEditFilter({
            ...productQuery.filter,
            ProductGroupId: null,
            SupplierId: null,
            SortingColumn: null,
            ...this.filterSettings,
            searchString: "",
        });
    }
    onEditFilter(...args) {
        const {
            editQueryFilter,
            flowControl,
        } = this.props;
        flowControl(async () => {
            await editQueryFilter(...args);
        });
    }
    loadMoreSearchResaults() {
        const {
            deviceType,
            loadMoreSearchedProducts,
        } = this.props;
        const productDisplayHeight = this.calculateProductDisplayHeight();
        const rowsToLoad = (Math.floor(productDisplayHeight/parseInt(scssVariables.productItemHeight))+2);
        // rowsToLoad * itemsPerRow
        switch(deviceType){
        case "xs":
        case "sm":
            loadMoreSearchedProducts( rowsToLoad*2 );
            break;
        case "md":
            loadMoreSearchedProducts( rowsToLoad*4 );
            break;
        case "lg":
            loadMoreSearchedProducts( rowsToLoad*6 );
            break;
        default:
            loadMoreSearchedProducts( rowsToLoad*8 );
            break;
        }
    }

    calculateCartHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }

    calculateProductDisplayHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;

        if( deviceType==="xs" ) {
            //shopping cart in menu form
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        } else {
            //title tab height
            productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;
            productDisplayHeight -= parseInt(scssVariables.titleTabHeight);
            //searchbar height
            productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        }
        //product display padding
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }

    calculateProductDisplayWidth() {
        const {
            deviceType,
            width,
        } = this.props;

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";

        let productDisplayWidth = width;
        if( deviceType==="xs" ) {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        } else {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]);//no padding on the right side(Attached to it)
            //page padding
            productDisplayWidth -= parseInt(isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth);
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        }

        return productDisplayWidth;
    }

    render() {
        const {
            deviceType,
            localization,
            width,
            height,
            addRemoveProductToTobaccoBag,
            addTobaccoBag,
            clearAll,
            submitTobaccoReturn,
            editQueryFilter,
            productQuery,
            tobacco,
            editTobacco,
            edditSupplierBag,
            validateBagNumber,
            setModal,
            setDropDown,
            clearQuery,
            pickupTobaccoDefault,
            freightChargePickupTobacco,
            saveTobaccoReturn,
        } = this.props;

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";
        const cartHeight = this.calculateCartHeight();
        const shiftCartUp = `-${parseInt(scssVariables.cardMargin)*2 + parseInt(scssVariables.titleTabHeight)}px`;
        const productDisplayHeight = this.calculateProductDisplayHeight();
        const productDisplayWidth = this.calculateProductDisplayWidth();
        const shiftCartToRight = scssVariables[`${deviceType}ContentPadding`];

        /* eslint-disable react/jsx-no-bind */
        return deviceType==="xs" ? (
            <div style={{display:"flex", height:`${height-1}px`, flexDirection:"column", position:"relative"}} >
                <div style={{width:`${productDisplayWidth}px`, height:"100%", flex:"0 0"}} >
                    <TobaccoDisplayCard
                        localization={localization}
                        addRemoveProductToTobaccoBag={addRemoveProductToTobaccoBag}
                        editQueryFilter={editQueryFilter}
                        height={productDisplayHeight}
                        width={productDisplayWidth}
                        loadMoreSearchResaults={this.loadMoreSearchResaults}
                        productQuery={productQuery}
                        deviceType={deviceType}
                        activeTobacco={tobacco}
                        setModal={setModal}
                        setDropDown={setDropDown}
                    />
                </div>
                <TobaccoReturnCart 
                    localization={localization}
                    deviceType={deviceType}
                    width={width}
                    height={cartHeight}
                    tobacco={tobacco}
                    addRemoveProductToTobaccoBag={addRemoveProductToTobaccoBag}
                    addTobaccoBag={addTobaccoBag}
                    clearAll={clearAll}
                    submitTobaccoReturn={submitTobaccoReturn}
                    saveTobaccoReturn={saveTobaccoReturn}
                    editTobacco={editTobacco}
                    edditSupplierBag={edditSupplierBag}
                    validateBagNumber={validateBagNumber}
                    setModal={setModal}
                    pickupTobaccoDefault={pickupTobaccoDefault}
                    freightChargePickupTobacco={freightChargePickupTobacco}
                />
            </div>
        ) : (
            <div style={{display:"flex", height:`${productDisplayHeight}px`}} >
                <div style={{display:"flex", flexDirection:"column", width:`${productDisplayWidth}px`, height:"inherit"}} >
                    <SearchBar
                        clearQuery={clearQuery}
                        localization={localization}
                        useFilter={true}
                        filter={{
                            ...productQuery.filter,
                            ReturnTobacco: true,
                            OnlyCampaigns: false,
                            OnlyNews: false,
                            OnlyLastSold: false,
                        }}
                        productQuery={productQuery}
                        onEdit={this.onEditFilter}
                        deviceType={deviceType}
                        usingSubmit={true}
                        setModal={setModal}
                        setDropDown={setDropDown}
                    />
                    <TobaccoDisplayCard
                        localization={localization}
                        addRemoveProductToTobaccoBag={addRemoveProductToTobaccoBag}
                        editQueryFilter={editQueryFilter}
                        height={productDisplayHeight}
                        width={productDisplayWidth}
                        loadMoreSearchResaults={this.loadMoreSearchResaults}
                        productQuery={productQuery}
                        deviceType={deviceType}
                        activeTobacco={tobacco}
                        setModal={setModal}
                        setDropDown={setDropDown}
                    />
                </div>
                <div style={{height:"100%", position:"relative", left:shiftCartToRight, top:shiftCartUp, flex:`0 0 ${isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth}`}} >
                    <TobaccoReturnCart 
                        localization={localization}
                        deviceType={deviceType}
                        width={width}
                        height={cartHeight}
                        tobacco={tobacco}
                        addRemoveProductToTobaccoBag={addRemoveProductToTobaccoBag}
                        addTobaccoBag={addTobaccoBag}
                        clearAll={clearAll}
                        submitTobaccoReturn={submitTobaccoReturn}
                        saveTobaccoReturn={saveTobaccoReturn}
                        editTobacco={editTobacco}
                        edditSupplierBag={edditSupplierBag}
                        validateBagNumber={validateBagNumber}
                        setModal={setModal}
                        pickupTobaccoDefault={pickupTobaccoDefault}
                        freightChargePickupTobacco={freightChargePickupTobacco}
                    />
                </div>
            </div>
        );
        /* eslint-enable react/jsx-no-bind */
    }
}

HistoryTobakComponent.propTypes = {
    deviceType: PropTypes.string.isRequired,
    flowControl: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    localization: Localization.propTypes.isRequired,
    signedInAs: PropTypes.string.isRequired,
    addRemoveProductToTobaccoBag: PropTypes.func.isRequired,
    addTobaccoBag: PropTypes.func.isRequired,
    clearAll: PropTypes.func.isRequired,
    submitTobaccoReturn: PropTypes.func.isRequired,
    saveTobaccoReturn: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func.isRequired,
    loadMoreSearchedProducts: PropTypes.func.isRequired,
    productQuery: PropTypes.object.isRequired,
    tobacco: PropTypes.object.isRequired,
    editTobacco: PropTypes.func.isRequired,
    edditSupplierBag: PropTypes.func.isRequired,
    validateBagNumber: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    getTobaccoSuppliers: PropTypes.func.isRequired,
    getSavedTobaccoReturn: PropTypes.func.isRequired,
    prepareQueryOptions: PropTypes.func.isRequired,
    getBoughtProducts: PropTypes.func.isRequired,
    getNewProducts: PropTypes.func.isRequired,
    clearQuery: PropTypes.func.isRequired,
    pickupTobaccoDefault: PropTypes.bool.isRequired,
    freightChargePickupTobacco: PropTypes.number,
};